import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPublicEvents as apiFetchPublicEvents, fetchEventById as apiFetchEventById } from '@/services/eventApi'

// Async thunk — fetch all public events
export const fetchPublicEvents = createAsyncThunk(
  'events/fetchPublicEvents',
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await apiFetchPublicEvents(params)
      return data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch events')
    }
  }
)

// Async thunk — fetch single event by ID
export const fetchEventById = createAsyncThunk(
  'events/fetchEventById',
  async (id, { rejectWithValue }) => {
    try {
      const data = await apiFetchEventById(id)
      return data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch event')
    }
  }
)

const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    events: [],
    selectedEvent: null,
    isLoading: false,
    isEventLoading: false,
    error: null,
    eventError: null,
  },
  reducers: {
    clearSelectedEvent: (state) => {
      state.selectedEvent = null
      state.eventError = null
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPublicEvents
      .addCase(fetchPublicEvents.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchPublicEvents.fulfilled, (state, action) => {
        state.isLoading = false
        state.events = action.payload.data?.events || []
      })
      .addCase(fetchPublicEvents.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload || 'Failed to fetch events'
      })
      // fetchEventById
      .addCase(fetchEventById.pending, (state) => {
        state.isEventLoading = true
        state.eventError = null
      })
      .addCase(fetchEventById.fulfilled, (state, action) => {
        state.isEventLoading = false
        state.selectedEvent = action.payload.data?.event || null
      })
      .addCase(fetchEventById.rejected, (state, action) => {
        state.isEventLoading = false
        state.eventError = action.payload || 'Failed to fetch event'
      })
  },
})

export const { clearSelectedEvent, clearError } = eventsSlice.actions
export default eventsSlice.reducer
